
import { computed, getCurrentInstance, PropType, ref } from 'vue'
import {
  createAmpTranslatedOfferDetailsInstance,
  createTranslatedOfferDetailsInstance,
  isMobileDTO,
  isHomeDTO,
  isBundleDTO,
  createTranslatedOfferBenefitsInstance, isMobileOffer,
  Offer, TranslatableContext,
} from '@alao-frontend/core'
import OfferMainDetails from '~/components/offers/NewOfferCard/OfferMainDetails.vue'
import OfferOptions from '~/components/offers/OfferOptions'
import OfferBenefitBadge from '~/components/offers/benefits/OfferBenefitBadge.vue'
import AppProviderRating from '~/components/AppProviderRating/AppProviderRating.vue'
import OfferCardExclusiveLabel from '~/components/offers/NewOfferCard/OfferCardExclusiveLabel.vue'

export default {
  name: 'OfferCardMain',
  components: {
    OfferMainDetails,
    OfferOptions,
    OfferBenefitBadge,
    AppProviderRating,
    OfferCardExclusiveLabel,
  },
  props: {
    offer: { type: Object as PropType<Offer>, required: true },
    highlightOptions: { type: Boolean, default: false },
    endDateInFewDays: { type: String, default: null },
    progressBar: { type: Number, default: null },
    effectivePercent: { type: Number, default: 0 },
  },
  setup (props:any) {
    const instance = getCurrentInstance()

    const $t = computed(() => {
      return (key: string, props: any) =>
        instance?.proxy?.$i18n?.t(key, props) || ''
    })
    /**
  createTranslatedOfferDetailsInstance,
  isMobileDTO,
  isHomeDTO,
  isBundleDTO,
     */
    const details = ref<any>(
      isMobileDTO(props.offer.dto) || isHomeDTO(props.offer.dto) || (isBundleDTO(props.offer.dto) && !(props.offer.dto as any).product)
        ? createTranslatedOfferDetailsInstance(
          props.offer,
          { t: $t } as unknown as TranslatableContext,
        )
        : createAmpTranslatedOfferDetailsInstance(
          props.offer,
          { t: $t } as unknown as TranslatableContext,
        ),
    )
    const benefits = ref(createTranslatedOfferBenefitsInstance(
      props.offer,
      { t: $t } as unknown as TranslatableContext))

    const detailedList = computed(() => {
      if (isMobileOffer(props.offer)) {
        return details.value.alaoPromoDetailedList
      }
      return details.value.mainList
    })
    return {
      ...props,
      $t,
      details,
      benefits,
      detailedList,
    }
  },
}
